import {environment} from '../../../environments/environment';

export const DATABASE_KEY = Object.freeze({
  cartsProduct: 'OSUDH_KINI_USER_CART_' + environment.VERSION,
  userCart: 'OSUDH_KINI_USER_CART_' + environment.VERSION,
  userWishList: 'OSUDH_KINI_USER_CART_' + environment.VERSION,
  userPrescription: 'OSUDH_KINI_USER_CART_' + environment.VERSION,
  productLayout: 'OSUDH_KINI_PRODUCT_LAYOUT' + environment.VERSION,
  encryptUserLogin: 'OSUDH_KINI_USER_1_' + environment.VERSION,
  signUpHoldData: 'OSUDH_KINI_SIGNUP_HOLD_DATA' + environment.VERSION,
  searchHoldData: 'OSUDH_KINI_SEARCH_HOLD_DATA' + environment.VERSION,
});

export const PDF_MAKE_LOGO = 'assets/images/brand/logo/trustpointpharma.png';
export type SEO_PAGE_TYPES = 'home_page' | 'about_us_page' | 'contact_us_page' | 'product_list_page' | 'login_page' | 'blog_page' |  'category_page' ;



export const DELIVERY_TIMES: any[] =  [
  // {value: '8.30 am to 10.00 am', viewValue: '8.30 am to 10.00 am', end: 6},
  // {value: '10.00 am to 11.30 am', viewValue: '10.00 am to 11.30 am', end: 8},
  // {value: '11.30 am to 01.00 pm', viewValue: '11.30 am to 01.00 pm', end: 9},
  // {value: '01.00 pm to 02.30 pm', viewValue: '01.00 pm to 02.30 pm', end: 11},
  // {value: '02.30 pm to 04.00 pm', viewValue: '02.30 pm to 04.00 pm', end: 13},
  // {value: '04.00 pm to 05.30 pm', viewValue: '04.00 pm to 05.30 pm', end: 14},
  // {value: '05.30 pm to 07.00 pm', viewValue: '05.30 pm to 07.00 pm', end: 15},
  // {value: '07.00 pm to 08.30 pm', viewValue: '07.00 pm to 08.30 pm', end: 17},


  {value: '08:30 am-09:30 am', viewValue: '08:30 am-09:30 am', end: 6},
  {value: '09:30 am-10:30 am', viewValue: '09:30 am-10:30 am', end: 7},
  {value: '10:30 am-11:30 am', viewValue: '10:30 am-11:30 am', end: 8},
  {value: '11:30 am-12:30 pm', viewValue: '11:30 am-12:30 pm', end: 9},
  {value: '12:30 pm-01:30 pm', viewValue: '12:30 pm-01:30 pm', end: 10},
  {value: '01:30 pm-02:30 pm', viewValue: '01:30 pm-02:30 pm', end: 11},
  {value: '02:30 pm-03:30 pm', viewValue: '02:30 pm-03:30 pm', end: 12},
  {value: '03:30 pm-04:30 pm', viewValue: '03:30 pm-04:30 pm', end: 13},
  {value: '04:30 pm-05:30 pm', viewValue: '04:30 pm-05:30 pm', end: 14},
  {value: '05:30 pm-06:30 pm', viewValue: '05:30 pm-06:30 pm', end: 15},
  {value: '06:30 pm-07:30 pm', viewValue: '06:30 pm-07:30 pm', end: 16},
  {value: '07:30 pm-08:30 pm', viewValue: '07:30 pm-08:30 pm', end: 17},
  {value: '08:30 pm-09:30 pm', viewValue: '08:30 pm-09:30 pm', end: 18},
  {value: '11:30 pm-08:00 am', viewValue: '11:30 pm-08:00 am', end: 19},
];
